import * as yup from 'yup';

export const validationSchemaFilter = yup.object().shape({
  dateFrom: yup.date().nullable().typeError('Data non valida').required('Campo obbligatorio'),
  dateTo: yup
    .date()
    .nullable()
    .required('Campo obbligatorio')
    .typeError('Data non valida')
    .when('dateFrom', (dateFrom: Date, formvalidationSchema) => {
      if (dateFrom?.toString() === 'Invalid Date') {
        return formvalidationSchema.nullable();
      }
      return dateFrom
        ? formvalidationSchema.min(dateFrom, 'La data deve essere maggiore o uguale della Data dal')
        : formvalidationSchema.nullable();
    }),
});

export const validationSchemaTable = yup.object().shape({
  selected: yup.array().nullable().min(1, 'Selezionare almeno un certificato'),
});
